import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import topbarFr from './locales/fr/components/topbar_fr.json'; // Import French translations
import topbarAr from './locales/ar/components/topbar_ar.json'; // Import Arabic translations

import carouselFr from './locales/fr/components/carousel_fr.json';
import carouselAr from './locales/ar/components/carousel_ar.json';

import carouselcardFr from './locales/fr/components/carouselcard_fr.json'; // Import French translations
import carouselcardAr from './locales/ar/components/carouselcard_ar.json'; // Import Arabic translations

import footerFr from './locales/fr/components/footer_fr.json'; // Import French translations
import footerAr from './locales/ar/components/footer_ar.json'; // Import Arabic translations

import horizontalhotelcardFr from './locales/fr/components/horizontalhotelcard_fr.json'; // Import French translations
import horizontalhotelcardAr from './locales/ar/components/horizontalhotelcard_ar.json'; // Import Arabic translations

import hotelcardFr from './locales/fr/components/hotelcard_fr.json'; // Import French translations
import hotelcardAr from './locales/ar/components/hotelcard_ar.json'; // Import Arabic translations
// Define resources with the correct variable names

import hotelroomFr from './locales/fr/components/hotelroom_fr.json'; // Import French translations
import hotelroomAr from './locales/ar/components/hotelroom_ar.json'; // Import Arabic translations

import navbarFr from './locales/fr/components/navbar_fr.json'; // Import French translations
import navbarAr from './locales/ar/components/navbar_ar.json'; // Import Arabic translations

import partnersFr from './locales/fr/components/partners_fr.json'; // Import French translations
import partnersAr from './locales/ar/components/partners_ar.json'; // Import Arabic translations

import searchbarFr from './locales/fr/components/searchbar_fr.json'; // Import French translations
import searchbarAr from './locales/ar/components/searchbar_ar.json'; // Import Arabic translations

import serviceslistFr from './locales/fr/components/serviceslist_fr.json'; // Import French translations
import serviceslistAr from './locales/ar/components/serviceslist_ar.json'; // Import Arabic translations

import travelcardFr from './locales/fr/components/travelcard_fr.json'; // Import French translations
import travelcardAr from './locales/ar/components/travelcard_ar.json'; // Import Arabic translations

import volcardFr from './locales/fr/components/volcard_fr.json'; // Import French translations
import volcardAr from './locales/ar/components/volcard_ar.json'; // Import Arabic translations

//PAGES

import checkouthotelFr from './locales/fr/pages/checkouthotel_fr.json'; // French translations
import checkouthotelAr from './locales/ar/pages/checkouthotel_ar.json'; // Arabic translations

import checkoutvolFr from './locales/fr/pages/checkoutvol_fr.json'; // French translations
import checkoutvolAr from './locales/ar/pages/checkoutvol_ar.json'; // Arabic translations

import forgotpasswordFr from './locales/fr/pages/forgotpassword_fr.json'; // French translations
import forgotpasswordAr from './locales/ar/pages/forgotpassword_ar.json'; // Arabic translations

import homeFr from './locales/fr/pages/home_fr.json'; // French translations
import homeAr from './locales/ar/pages/home_ar.json'; // Arabic translations

import hotelFr from './locales/fr/pages/hotel_fr.json'; // French translations
import hotelAr from './locales/ar/pages/hotel_ar.json'; // Arabic translations

import hotelsFr from './locales/fr/pages/hotels_fr.json'; // French translations
import hotelsAr from './locales/ar/pages/hotels_ar.json'; // Arabic translations

import loginFr from './locales/fr/pages/login_fr.json'; // French translations
import loginAr from './locales/ar/pages/login_ar.json'; // Arabic translations

import notfoundFr from './locales/fr/pages/notfound_fr.json'; // French translations
import notfoundAr from './locales/ar/pages/notfound_ar.json'; // Arabic translations

import profileFr from './locales/fr/pages/profile_fr.json'; // French translations
import profileAr from './locales/ar/pages/profile_ar.json'; // Arabic translations

import profileinformationsFr from './locales/fr/pages/profileinformations_fr.json'; // French translations
import profileinformationsAr from './locales/ar/pages/profileinformations_ar.json'; // Arabic translations


import comptinformationsFr from './locales/fr/pages/comptinformations_fr.json'; // French translations
import comptinformationsAr from './locales/ar/pages/comptinformations_ar.json'; // Arabic translations

import reservationdemandesFr from './locales/fr/pages/reservationdemandes_fr.json'; // French translations
import reservationdemandesAr from './locales/ar/pages/reservationdemandes_ar.json'; // Arabic translations

import supportFr from './locales/fr/pages/support_fr.json'; // French translations
import supportAr from './locales/ar/pages/support_ar.json'; // Arabic translations

import myTicketsFr from './locales/fr/pages/myTickets_fr.json'; // French translations
import myTicketsAr from './locales/ar/pages/myTickets_ar.json'; // Arabic translations

import registerFr from './locales/fr/pages/register_fr.json'; // French translations
import registerAr from './locales/ar/pages/register_ar.json'; // Arabic translations

import reserveFr from './locales/fr/pages/reserve_fr.json'; // French translations
import reserveAr from './locales/ar/pages/reserve_ar.json'; // Arabic translations

import demandeFr from './locales/fr/pages/demande_fr.json'; // French translations
import demandeAr from './locales/ar/pages/demande_ar.json'; // Arabic translations

import devisFr from './locales/fr/pages/devis_fr.json'; // Import French translations
import devisAr from './locales/ar/pages/devis_ar.json'; // Import Arabic translations

import resetPasswordFr from './locales/fr/pages/resetPassword_fr.json'; // Import French translations
import resetPasswordAr from './locales/ar/pages/resetPassword_ar.json'; // Import Arabic translations

import ticketDetailsFr from './locales/fr/pages/ticketDetails_fr.json'; // Import French translations
import ticketDetailsAr from './locales/ar/pages/ticketDetails_ar.json'; // Import Arabic translations

import usFr from './locales/fr/pages/us_fr.json'; // Import French translations
import usAr from './locales/ar/pages/us_ar.json'; // Import Arabic translations

import visaFr from './locales/fr/pages/visa_fr.json';
import visaAr from './locales/ar/pages/visa_ar.json';

import voyageFr from './locales/fr/pages/voyage_fr.json'; // Import French translations
import voyageAr from './locales/ar/pages/voyage_ar.json'; // Import Arabic translations

import voyageorgFr from './locales/fr/pages/voyageorg_fr.json';
import voyageorgAr from './locales/ar/pages/voyageorg_ar.json';

import preFr from './locales/fr/pages/pre_fr.json';
import preAr from './locales/ar/pages/pre_ar.json';

import tarifFr from './locales/fr/pages/tarif_fr.json';
import tarifAr from './locales/ar/pages/tarif_ar.json';

import volsFr from './locales/fr/pages/vols_fr.json';
import volsAr from './locales/ar/pages/vols_ar.json';

import visitalgeriaFr from './locales/fr/pages/visitalgeria_fr.json';
import visitalgeriaAr from './locales/ar/pages/visitalgeria_ar.json';






const resources = {
  fr: {
    translation: {...topbarFr,
        ...carouselFr,
        ...carouselcardFr,
        ...footerFr,
        ...horizontalhotelcardFr,
        ...hotelcardFr,
        ...hotelroomFr,
        ...navbarFr,
        ...partnersFr,
        ...searchbarFr,
        ...serviceslistFr,
        ...travelcardFr,
        ...volcardFr,


        ...checkouthotelFr,
        ...checkoutvolFr,
        ...forgotpasswordFr,
        ...homeFr,
        ...hotelFr,
        ...hotelsFr,
        ...loginFr,
        ...notfoundFr,
        ...profileFr,
        ...profileinformationsFr,
        ...comptinformationsFr,
        ...reservationdemandesFr,
        ...supportFr,
        ...myTicketsFr,
        ...registerFr,
        ...reserveFr,
        ...demandeFr,
        ...devisFr,
        ...resetPasswordFr,
        ...ticketDetailsFr,
        ...usFr,
        ...visaFr,
        ...voyageFr,
        ...voyageorgFr,
        ...preFr,
        ...tarifFr,
        ...volsFr,
        ...visitalgeriaFr,
    },
  },
  ar: {
    translation: {...topbarAr,
        ...carouselAr,
        ...carouselcardAr,
        ...footerAr,
        ...horizontalhotelcardAr,
        ...hotelcardAr,
        ...hotelroomAr,
        ...navbarAr,
        ...partnersAr,
        ...searchbarAr,
        ...serviceslistAr,
        ...travelcardAr ,
        ...volcardAr ,
        

        ...checkouthotelAr,
        ...checkoutvolAr,
        ...forgotpasswordAr,
        ...homeAr,
        ...hotelAr,
        ...hotelsAr,
        ...loginAr,
        ...notfoundAr,
        ...profileAr,
        ...profileinformationsAr,
        ...comptinformationsAr,
        ...reservationdemandesAr,
        ...supportAr,
        ...myTicketsAr,
        ...registerAr,
        ...reserveAr,
        ...demandeAr,
        ...devisAr,
        ...resetPasswordAr,
        ...ticketDetailsAr,
        ...usAr,
        ...visaAr,
        ...voyageAr,
        ...voyageorgAr,
        ...preAr,
        ...tarifAr,
        ...volsAr,
        ...visitalgeriaAr,
      },
  },
};

const savedLanguage = localStorage.getItem('language') || 'fr';

// Initialize i18next
i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage, // Default language is French
  fallbackLng: 'fr', // Fallback language is French
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;